import React from 'react';
import { Card } from './card';
import accountbanque from '../../../../../../../assets/images/svg/060-bank-account.svg';
import { BankAccountType } from '../../../../../../../constants/models/servicePayloads/bankAccountType';
import { PasService } from './pasService';

export const Credit = ({ branch, isMain, globalPayload, setGlobalPayload, displayComments, disableModifications}) => {
    const cardTypes = [BankAccountType.CreditVoiture, BankAccountType.CreditImmobilier, BankAccountType.CreditTravaux,
    BankAccountType.CreditConsummation, BankAccountType.CreditAutre];

    return (
        <div className="grid grid-md-min grid-lg-tight grid-lg-4">
            {
                cardTypes.map((name, index) => {
                    return <Card key={index} cardType={name} icon={accountbanque} branch={branch} isMain={isMain} globalPayload={globalPayload} setGlobalPayload={setGlobalPayload}  displayComments={displayComments} disableModifications={disableModifications}/>
                })
            }
            {/* <PasService icon={accountbanque} cardType={BankAccountType.PasCredit} /> */}
        </div>
    );
}